@if (masterDataApiCallStatus() === 'COMPLETED_SUCCESFULLY') {
  <form [formGroup]="headerForm">
    @if (displayedExceptionReason) {
      <div class="m-t-8 m-b-4">
        <mc-notification
          appearance="info"
          fit="small"
          icon="info-circle"
          verticalalign="middle"
          heading="Sales restriction overridden"
          [body]="'Reason: ' + displayedExceptionReason + '. This reason will be saved with the work order.'">
        </mc-notification>
      </div>
    }

    <div class="aems-card m-b-12">
      <div class="pure-g">
        <div class="pure-u-md-8-24 pure-u-lg-8-24 p-b-16 p-r-8">
          <mc-select ngDefaultControl formControlName="cause" label="Cause" placeholder="Select an option" fit="small">
            @for (cause of causes(); track $index) {
              <mc-option [attr.data-cy]="cause.code" [value]="cause">
                {{ cause.displayText }}
              </mc-option>
            }
          </mc-select>
        </div>
        @if (isThirdPartyDamage()) {
          <div class="pure-u-md-8-24 pure-u-lg-8-24 p-b-16 p-r-8">
            <mc-input
              ngDefaultControl
              label="3rd Party Port"
              formControlName="thirdPartyPort"
              placeholder="Type to search"
              fit="small"
              [attr.invalid]="isControlInErrorState(headerForm.controls.thirdPartyPort)">
              @if (headerForm.controls.thirdPartyPort.hasError('required')) {
                <span slot="errormessage">3rd party port is required</span>
              }
              @if (headerForm.controls.thirdPartyPort.hasError('maxlength')) {
                <span slot="errormessage">Max Length should be 10</span>
              }
            </mc-input>
          </div>
        }
        <div class="pure-u-md-8-24 pure-u-lg-8-24 p-b-16 p-r-8">
          <mc-input
            ngDefaultControl
            formControlName="vendorRefNo"
            label="Vendor Ref No. (Optional)"
            [attr.invalid]="isControlInErrorState(headerForm.controls.vendorRefNo)"
            placeholder="Vendor Ref No."
            fit="small">
            @if (headerForm.controls.vendorRefNo.hasError('maxLength')) {
              <span slot="errormessage">Vendor Ref No. should not exceed 20 characters</span>
            }
            @if (headerForm.controls.vendorRefNo.hasError('pattern')) {
              <span slot="errormessage">, & % not allowed</span>
            }
          </mc-input>
        </div>
      </div>
      <div class="pure-g">
        <div class="pure-u-md-6-24 pure-u-lg-6-24 p-b-16 p-r-8 m-t-20">
          <div>{{ workOrder?.equipmentNumber }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal" style="line-height: 10px">Equipment Number</div>
        </div>
        <div class="pure-u-md-6-24 pure-u-lg-6-24 p-b-16 p-r-8 m-t-20">
          <div ngDefaultControl formControlName="shopCode">{{ selectedShop().maintenanceShopCode }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal" style="line-height: 10px">Shop Code</div>
        </div>
        <div ngDefaultControl formControlName="mode" class="pure-u-md-4-24 pure-u-lg-4-24 p-b-16 p-r-8 m-t-20">
          <div>{{ selectedMode().code }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal" style="line-height: 10px">Mode</div>
        </div>
        <div class="pure-u-md-4-24 pure-u-lg-4-24 p-b-16 p-r-8 m-t-20">
          <div>{{ selectedShop().maintenanceShopCurrency.currencyCode }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal" style="line-height: 10px">Currency</div>
        </div>
        <div class="pure-u-md-4-24 pure-u-lg-4-24 p-b-16 p-r-8 m-t-20">
          <div>{{ gensetHours() ?? '-' }}</div>
          <div class="mds-neutral--weak__text-color mds-text--x-small-normal">Gen Hours</div>
        </div>
      </div>
    </div>
  </form>
}
